module.exports = __webpack_public_path__ + "static/media/heroes.1f4b5508.png";